// @flow
import axios from "axios";
import config, { socket_endpoint } from "../config";
import { authToken, apiVersion } from "./Utils";
import {
    setOrganizationList,
    setOrganization,
    setWhiteboardAssets,
    setWhiteboardCategories,
    setAppBaseWebConfig,
    setChordsData,
    setChordsImg,
    setMyRecordingsData,
    setRegisteredDevice,
    setAvilableUserIP
} from "../redux/tool-webjam-v2/actions";
import { _getRouteToRender } from "../../app/getRouteToRender";
import { hideApiLoader, setAuthVerify, setDecodedData, setRoomorIpAddress, showApiLoader } from "../redux/tool-webjam/actions";
import { updateSettings } from "../../base/settings";
import { socketEmit } from "../../../../socket";
import { dispatch, getBaseConfig, getStore } from "../Utils";
import { batch } from "react-redux";
import { FEATURE_CUSTOM_REDUX } from "../constant";
import { removeTokenSession } from "../authorize/CommonFunction";
import { CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME, Constant } from "../../webjam/constant";
import { setNotificationMessage } from "./components/payment/payment-reducer/actions";
import { NotificationType } from "./components/payment/Utils";
import { stripeMessage } from "./messages";
import { setPrejoinAvailableDevices, setMyDevicesData } from "../redux/tool-webjam-v3/actions";
import { ct, dynamicMessageLocale } from "../constant-Utils";

const base_url = config.socket_endpoint + (getBaseConfig("apiVersion") || apiVersion);

const main_url = config.socket_endpoint;
const social_api_url = getBaseConfig("socialBaseUrl");

console.log("CURRENT_ROOM_LOCATION requestd ", CURRENT_ROOM_LOCATION)

declare var APP: Object;

export const userLogin = (data) => {
    return axios({
        method: 'post',
        url: base_url + "/user_logged_in",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}


export const userSignup = (data) => {
    return axios({
        method: 'post',
        url: base_url + "/register_user",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const userLogout = (data, token) => {
    return axios({
        method: 'post',
        url: base_url + "/logout",
        data,
        headers: {
            Authorization: "Bearer " + token
        }
    })
        .then((res) => {
            return {
                status: 1,
                data: res.data
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const checkUserSession = async (token, additional = null) => {
    return axios({
        method: 'get',
        url: base_url + "/validateToken",
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data,
                }
            }
            return {
                status: 0,
                data: res.data
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}


export const claimRoomRequest = (data) => {
    let token = authToken()
    return axios({
        method: 'post',
        url: base_url + "/create_owner_Room",
        data,
        headers: token
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const getRoomDetail = (roomname) => {
    let token = authToken()
    return axios({
        method: 'get',
        url: base_url + "/user_session/chrome/1.1.1.1/1.1.1.1/" + roomname,
        headers: token
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export function saveDuetLog(data) {
    try {
        axios({
            method: "POST",
            url: main_url + "/common/save-logs",
            data
        })
    } catch (e) {
        console.log("saveDuetLog error =>", e)
    }
}

export const getOrganizationListAuth = (token, decodedData) => {
    return (dispatch, getState) => {
        axios({
            method: 'GET',
            url: main_url + "/session/organizations"
        }).then((res) => {
            if (res.data.status) {
                if (res.data.data.length) {
                    dispatch(setOrganizationList(res.data.data))

                    let orgs = res.data.data;
                    let org_info = "";
                    let loca = window.location.origin;
                    orgs.map(e => {
                        if (e.domain == loca) {
                            org_info = e;
                        }
                    })
                    if (org_info) {
                        batch(() => {
                            dispatch(setOrganization(org_info))
                            dispatch(validateAuthToken(token, org_info._id, decodedData))
                        })
                    } else {

                        removeTokenSession(5)
                        alert(ct("rta-trmc.dialogs.orgNotRegistered"))
                        saveDuetLog({
                            token,
                            orgs,
                            org_detail: org_info,
                            message: "my organization not found in list",
                            type: 1,
                            domain: window.location.origin,
                            origin: window.location.href
                        })
                        window.location.href = window.location.origin;
                    }
                } else {

                    removeTokenSession(6)
                    alert(ct("rta-trmc.dialogs.orgNotRegistered"))
                    saveDuetLog({
                        token,
                        message: "organization list is empty",
                        type: 2,
                        domain: window.location.origin,
                        origin: window.location.href
                    })
                    window.location.href = window.location.origin;
                }

            }
        }).catch((error) => {
            removeTokenSession(7)
            saveDuetLog({
                token,
                message: error.message,
                type: 3,
                domain: window.location.origin,
                origin: window.location.href
            })
            if (error.response) {
                alert(ct("rta-trmc.dialogs.orgNotRegistered"))
                window.location.href = window.location.origin;

            }
        })
    }
}

export const getOrganizationList = () => {
    return (dispatch) => {
        axios({
            method: 'GET',
            url: main_url + "/session/organizations",
        })
            .then((res) => {
                if (res.data.status) {
                    let data = res.data.data;
                    if (data.length) {
                        let myDomain = window.location.origin;
                        let myOrg;
                        dispatch(setOrganizationList(data));
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].domain == myDomain) {
                                myOrg = data[i];
                                break;
                            }
                        }
                        if (myOrg) {
                            dispatch(setOrganization(myOrg));
                            dispatch(getWhiteboardAssets('?organization_id=' + myOrg?._id + "&room_name=" + CURRENT_ROOM_NAME + "&page_num=1"))
                        }
                    }
                }
            }).catch((error) => {
                if (error.response) {
                    console.log("getOrganizationList error =>", {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    })
                }
            })
    }
}

export const getWhiteboardAssets = (payload) => {
    return (dispatch) => {
        axios({
            method: 'GET',
            url: main_url + "/whiteboard/all-assets" + payload,
        })
            .then((res) => {
                let data = res.data.data;
                if (data?.length) {
                    dispatch(setWhiteboardAssets(data));
                } else {
                    dispatch(setWhiteboardAssets([]));
                }
            }).catch((error) => {
                if (error.response) {
                    console.log("getWhiteboardAssets error =>", {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    })
                }
            })
    }
}

export const addWhiteboardAssets = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/whiteboard/asset/create",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const getWhiteboardCategories = () => {
    return (dispatch) => {
        axios({
            method: 'GET',
            url: main_url + "/whiteboard/categories",
        })
            .then((res) => {
                let data = res.data.categories;
                if (data.length) {
                    let _data = []
                    data.map(async (e, index) => {
                        const category_name = await dynamicMessageLocale(e.category_name);
                        console.log({ category_name });
                        _data = [..._data, { ...e, category_name }];
                        if (data.length - 1 === index) {
                            dispatch(setWhiteboardCategories(_data));
                        }
                    });

                }
            }).catch((error) => {
                if (error.response) {
                    console.log("getWhiteboardCategories error =>", {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    })
                }
            })
    }
}

export const getChordsData = () => {
    return (dispatch) => {
        axios({
            method: 'GET',
            url: Constant.App.ServerUrl + "/common/get-chord-names",
        })
            .then((res) => {
                let data = res.data.data;
                if (res.data.success) {
                    dispatch(setChordsData(data));
                }
            }).catch((error) => {
                if (error.response) {
                    console.log("getChordsData error =>", {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    })
                }
            })
    }
}
export const getChordImages = (data) => {
    return (dispatch) => {
        return axios({
            method: 'POST',
            url: Constant.App.ServerUrl + "/common/get-chord-images",
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        })
            .then((res) => {
                // if (res.data.status) {
                //     dispatch(setChordsImg(res?.data?.data));
                // }
                return res?.data?.data
            }).catch((error) => {
                if (error.response) {
                    return {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    }
                }
            })
    }
}

export const validateAuthToken = (token, organization, decodedData) => {
    return (dispatch, getState) => {
        dispatch(updateSettings({
            displayName: decodedData.firstname
        }))
        axios({
            method: 'GET',
            url: main_url + "/session/check-token?organization_id=" + organization + "&token=" + token
        }).then((res) => {
            if (res.data.status) {
                sessionStorage.removeItem("_at")
                dispatch(setDecodedData(decodedData))
                if (res.data.join_status) {
                    let timing = 0;
                    if (decodedData.teacher == true) {
                        let roomUrl = CURRENT_ROOM_LOCATION;
                        socketEmit('moderator_grant', {
                            location: roomUrl,
                            disableLobby: true,
                            time: 1000,
                            teacherAccess: true
                        });
                        timing = 4000;
                    }


                    setTimeout(function () {
                        dispatch(setAuthVerify({
                            status: true,
                            type: "join",
                            decodedData: decodedData
                        }))
                    }, timing)


                } else {
                    dispatch(setAuthVerify({
                        status: true,
                        type: "wait",
                        decodedData: decodedData
                    }))
                }
            } else {
                removeTokenSession(8)
                alert(ct("rta-trmc.dialogs.invalidAuthorization"))
                window.location.href = window.location.origin;
            }
        }).catch((error) => {
            removeTokenSession(9)
            if (error.response) {
                dispatch(setAuthVerify({
                    status: true,
                    type: "leave"
                }))
                window.location.href = window.location.origin;
                console.log("validateAuthToken error =>", {
                    error: error.response.status,
                    data: error?.response?.data
                })
            }
        })
    }
}

export const getRoomStatus = (token) => {

    return axios({
        method: 'GET',
        url: main_url + "/session/wait-screen" + token
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                join_status: res.data.join_status
            }
        }
        return {
            status: 0,
            join_status: false
        }
    }).catch((error) => {
        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const saveCustomMessage = (message, recipientID) => {
    const fromLang = message.split("/TRMC-LANG-CHANGE/");
    const { tokenDecodedData, authOrganization, authRoomUsers } = getStore(FEATURE_CUSTOM_REDUX);

    if (tokenDecodedData) {
        let message_type = 1;
        if (fromLang[0] != undefined) {
            if (fromLang[0].indexOf("file-TRMC-") != -1) {
                message_type = 2;
            }
        }
        let json = {
            message: fromLang[0],
            message_type: message_type
        };
        json = Object.assign(
            tokenDecodedData
            , json)

        json = Object.assign(
            authOrganization
            , json);
        if (authRoomUsers.length) {
            for (let i = 0; i < authRoomUsers.length; i++) {
                if (authRoomUsers[i].jitsiUserId == json.jitsiId) {
                    json.user_id = authRoomUsers[i].userId;
                    json.userId = authRoomUsers[i].userId;
                }
            }
        }

        if (recipientID) {
            json.isPrivate = "true";
            json.receiver_id = recipientID;
        }

        axios.post(`${main_url}/chat/send-text`, json).then(response => {
            console.log("saveCustomMessage success =>", response);
        }).catch(error => {
            console.log("saveCustomMessage error =>", error);
        });
    }
}

export const startJibriRecordingApi = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/v2/save-recording-data",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const getRecordingStreamingType = async (data) => {
    return await axios({
        method: 'GET',
        url: main_url + "/get-recording-type" + data
    })
}

export const getBufferDelayApi = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/host-buffer-delay",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const getVoiceDetect = (data) => {
    return axios({
        method: 'POST',
        url: Constant.App.chatTranslate + "/de-lang",
        data
    })
        .then((res) => {
            return res.data;
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

// music mode on/off api
export const musicModeStatus = (data) => {

    let method = data.method;
    delete data.method;
    return axios({
        method,
        url: main_url + "/session/music-mode" + (data?.query || ''),
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    musicMode: res.data.music_mode
                }
            }

            return {
                status: 0
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}


export const getSiteConfig = (data = '') => {
    return (dispatch, getState) => {
        return axios({
            url: main_url + "/common/config-data?domain=" + window.location.origin
        }).then((res) => {
            if (res.data.status) {
                let receiveData = res.data.data;
                let tools = receiveData.tools;
                if (receiveData?.whiteboard) {
                    tools.push("whiteboard")
                }

                if (receiveData?.chordChart) {
                    tools.push("chordChart")
                }

                if (receiveData?.guitarTuner) {
                    tools.push("guitarTuner")
                }

                if (receiveData?.latencyMetronome) {
                    tools.push("latencyMetronome")
                }

                if (receiveData?.metronome) {
                    tools.push("metronome")
                }

                if (receiveData?.piano) {
                    tools.push("piano")
                }

                if (receiveData?.scaleGenerator) {
                    tools.push("scaleGenerator")
                }

                if (receiveData?.drum) {
                    tools.push("drum")
                }
                if (receiveData?.myRecordings) {
                    tools.push("myRecordings")
                }

                let setData = {
                    allowedToolSync: receiveData.allowedToolSync,
                    tools,
                    ServerUrl: receiveData.apiUrl,
                    jitterBuffer: receiveData.jitterBuffer,
                    lobbyChat: receiveData.lobbyChat,
                    pianoUrl: receiveData.pianoUrl,
                    whiteBoardUrl: receiveData.whiteBoardUrl,
                    socketUrl: receiveData.socketUrl,
                    recordingUrl: receiveData.recordingUrl,
                    serverVarInHybridsession: receiveData.hybridServerKey,
                    serverVarRecordingStreaming: receiveData.recordingServerKey,
                    sendAnalytics: receiveData.sendAnalytics,
                    stemRecording: receiveData.stemRecording,
                    jitterBufferIP: receiveData.jitterBufferIP,
                }

                if (receiveData.hasOwnProperty("apiVersion")) {
                    setData = Object.assign(setData, {
                        apiVersion: receiveData.apiVersion
                    })
                }

                if (receiveData.hasOwnProperty("paidLecture")) {
                    setData = Object.assign(setData, {
                        paidLecture: receiveData.paidLecture
                    })
                }
                if (receiveData.hasOwnProperty("guestUser")) {
                    setData = Object.assign(setData, {
                        guestUser: receiveData.guestUser
                    })
                }

                if (receiveData.hasOwnProperty("customTutorial")) {
                    setData = Object.assign(setData, {
                        customTutorial: receiveData.customTutorial
                    })
                }

                if (receiveData.hasOwnProperty("socialAllowed")) {
                    setData = Object.assign(setData, {
                        socialAllowed: receiveData.socialAllowed
                    })
                }

                if (receiveData.hasOwnProperty("selectAutoHostCheckbox")) {
                    setData = Object.assign(setData, {
                        selectAutoHostCheckbox: receiveData.selectAutoHostCheckbox
                    })
                }

                if (receiveData.hasOwnProperty("noChangedRoomName")) {
                    setData = Object.assign(setData, {
                        noChangedRoomName: receiveData.noChangedRoomName
                    })
                }

                if (receiveData.hasOwnProperty("socialReferrerUrl")) {
                    setData = Object.assign(setData, {
                        socialReferrerUrl: receiveData.socialReferrerUrl
                    })
                }

                if (receiveData.hasOwnProperty("subscriptionRequired")) {
                    setData = Object.assign(setData, {
                        subscriptionRequired: receiveData.subscriptionRequired
                    })
                }

                if (receiveData.hasOwnProperty("isPaymentButtonDisabled")) {
                    setData = Object.assign(setData, {
                        isPaymentButtonDisabled: receiveData.isPaymentButtonDisabled
                    })
                }


                if (receiveData.hasOwnProperty("showRoomDashboard")) {
                    setData = Object.assign(setData, {
                        showRoomDashboard: receiveData.showRoomDashboard
                    })
                }

                if (receiveData.hasOwnProperty("socialInvite")) {
                    setData = Object.assign(setData, {
                        socialInvite: receiveData.socialInvite
                    })
                }

                if (receiveData.hasOwnProperty("showPreJoining")) {
                    setData = Object.assign(setData, {
                        showPreJoining: receiveData.showPreJoining
                    })
                }

                if (receiveData.hasOwnProperty("prejoinLoginRequired")) {
                    setData = Object.assign(setData, {
                        prejoinLoginRequired: receiveData.prejoinLoginRequired
                    })
                }

                if (receiveData.hasOwnProperty("calculateDevicePing")) {
                    setData = Object.assign(setData, {
                        calculateDevicePing: receiveData.calculateDevicePing
                    })
                }

                if (receiveData.hasOwnProperty("showDevicePreJoining")) {
                    setData = Object.assign(setData, {
                        showDevicePreJoining: receiveData.showDevicePreJoining
                    })
                }

                if (receiveData.hasOwnProperty("prejoinBackButton")) {
                    setData = Object.assign(setData, {
                        prejoinBackButton: receiveData.prejoinBackButton
                    })
                }

                if (receiveData.hasOwnProperty("showHomePageHomeIcon")) {
                    setData = Object.assign(setData, {
                        showHomePageHomeIcon: receiveData.showHomePageHomeIcon
                    })
                }

                if (receiveData.hasOwnProperty("saveUnClaimedRoom")) {
                    setData = Object.assign(setData, {
                        saveUnClaimedRoom: receiveData.saveUnClaimedRoom
                    })
                }

                if (receiveData.hasOwnProperty("showSignOutButton")) {
                    setData = Object.assign(setData, {
                        showSignOutButton: receiveData.showSignOutButton
                    })
                }

                if (receiveData.hasOwnProperty("showMenuList")) {
                    setData = Object.assign(setData, {
                        showMenuList: receiveData.showMenuList
                    })
                }

                if (receiveData.hasOwnProperty("prejoinRedirectToSocialButton")) {
                    setData = Object.assign(setData, {
                        prejoinRedirectToSocialButton: receiveData.prejoinRedirectToSocialButton
                    })
                }

                if (receiveData.hasOwnProperty("sidebarProfileIcon")) {
                    setData = Object.assign(setData, {
                        sidebarProfileIcon: receiveData.sidebarProfileIcon
                    })
                }

                if (receiveData.hasOwnProperty("manageHostServerName")) {
                    setData = Object.assign(setData, {
                        manageHostServerName: receiveData.manageHostServerName
                    })
                }

                if (receiveData.hasOwnProperty("sideBarMenuList")) {
                    setData = Object.assign(setData, {
                        sideBarMenuList: receiveData.sideBarMenuList
                    })
                }

                if (receiveData.hasOwnProperty("overlaySidebarMenuButton")) {
                    setData = Object.assign(setData, {
                        overlaySidebarMenuButton: receiveData.overlaySidebarMenuButton
                    })
                }

                if (receiveData.hasOwnProperty("showAllThirdPartyServers")) {
                    setData = Object.assign(setData, {
                        showAllThirdPartyServers: receiveData.showAllThirdPartyServers
                    })
                }

                if (receiveData.hasOwnProperty("confirmUserToAutoHost")) {
                    setData = Object.assign(setData, {
                        confirmUserToAutoHost: receiveData.confirmUserToAutoHost
                    })
                }

                if (receiveData.hasOwnProperty("deviceReconnecting")) {
                    setData = Object.assign(setData, {
                        deviceReconnecting: receiveData.deviceReconnecting
                    })
                }
                if (receiveData.hasOwnProperty("deviceReconnectingFailed")) {
                    setData = Object.assign(setData, {
                        deviceReconnectingFailed: receiveData.deviceReconnectingFailed
                    })
                }
                if (receiveData.hasOwnProperty("detectRecommendedHost")) {
                    setData = Object.assign(setData, {
                        detectRecommendedHost: receiveData.detectRecommendedHost
                    })
                }

                if (receiveData.hasOwnProperty("saveDeviceConnectSession")) {
                    setData = Object.assign(setData, {
                        saveDeviceConnectSession: receiveData.saveDeviceConnectSession
                    })
                }

                if (receiveData.hasOwnProperty("prejoinWithoutMic")) {
                    setData = Object.assign(setData, {
                        prejoinWithoutMic: receiveData.prejoinWithoutMic
                    })
                }

                if (receiveData.hasOwnProperty("canAllUserMakeHost")) {
                    setData = Object.assign(setData, {
                        canAllUserMakeHost: receiveData.canAllUserMakeHost
                    })
                }

                if (receiveData.hasOwnProperty("moderatorCanMakeHost")) {
                    setData = Object.assign(setData, {
                        moderatorCanMakeHost: receiveData.moderatorCanMakeHost
                    })
                }

                if (receiveData.hasOwnProperty("monitorHostTabChange")) {
                    setData = Object.assign(setData, {
                        monitorHostTabChange: receiveData.monitorHostTabChange
                    })
                }

                if (receiveData.hasOwnProperty("showE2eCheck")) {
                    setData = Object.assign(setData, {
                        showE2eCheck: receiveData.showE2eCheck
                    })
                }

                if (receiveData.hasOwnProperty("homeIconPathImage")) {
                    setData = Object.assign(setData, {
                        homeIconPathImage: receiveData.homeIconPathImage
                    })
                }

                let streamingPlatforms = receiveData.streamingPlatforms;
                if (receiveData?.youtube) {
                    streamingPlatforms.push("youtube")
                }

                if (receiveData?.tiktok) {
                    streamingPlatforms.push("tiktok")
                }

                if (receiveData?.facebook) {
                    streamingPlatforms.push("facebook")
                }

                if (receiveData.hasOwnProperty("showRoomsListing")) {
                    setData = Object.assign(setData, {
                        showRoomsListing: receiveData.showRoomsListing
                    })
                }

                if (receiveData.hasOwnProperty("showPreJoiningInConference")) {
                    setData = Object.assign(setData, {
                        showPreJoiningInConference: receiveData.showPreJoiningInConference
                    })
                }

                if (receiveData.hasOwnProperty("noDevicePreJoiningScreen")) {
                    setData = Object.assign(setData, {
                        noDevicePreJoiningScreen: receiveData.noDevicePreJoiningScreen
                    })
                }

                if (receiveData.hasOwnProperty("showSignInWithGoogle")) {
                    setData = Object.assign(setData, {
                        showSignInWithGoogle: receiveData.showSignInWithGoogle
                    })
                }

                if (receiveData.hasOwnProperty("viewShortcuts")) {
                    setData = Object.assign(setData, {
                        viewShortcuts: receiveData.viewShortcuts
                    })
                }

                if (receiveData.hasOwnProperty("hostHangupNew")) {
                    setData = Object.assign(setData, {
                        hostHangupNew: receiveData.hostHangupNew
                    })
                }

                if (receiveData.hasOwnProperty("checkNatType")) {
                    setData = Object.assign(setData, {
                        checkNatType: receiveData.checkNatType
                    })
                }

                if (receiveData.hasOwnProperty("prejoinAutoConnect")) {
                    setData = Object.assign(setData, {
                        prejoinAutoConnect: receiveData.prejoinAutoConnect
                    })
                }

                if (receiveData.hasOwnProperty("showJammingCapaility")) {
                    setData = Object.assign(setData, {
                        showJammingCapaility: receiveData.showJammingCapaility
                    })
                }

                if (receiveData.hasOwnProperty("hidePreJoinScreen")) {
                    setData = Object.assign(setData, {
                        hidePreJoinScreen: receiveData.hidePreJoinScreen
                    })
                }

                if (receiveData.hasOwnProperty("hideAskSubscriptionModal")) {
                    setData = Object.assign(setData, {
                        hideAskSubscriptionModal: receiveData.hideAskSubscriptionModal
                    })
                }

                if (receiveData.hasOwnProperty("showSoftwareVersion")) {
                    setData = Object.assign(setData, {
                        showSoftwareVersion: receiveData.showSoftwareVersion
                    })
                }

                if (receiveData.hasOwnProperty("autoDisableHybrid")) {
                    setData = Object.assign(setData, {
                        autoDisableHybrid: receiveData.autoDisableHybrid
                    })
                }

                if (receiveData.hasOwnProperty("showPushSpinnerLoader")) {
                    setData = Object.assign(setData, {
                        showPushSpinnerLoader: receiveData.showPushSpinnerLoader
                    })
                }

                if (receiveData.hasOwnProperty("hybridMsgTimer")) {
                    setData = Object.assign(setData, {
                        hybridMsgTimer: receiveData.hybridMsgTimer
                    })
                }

                if (receiveData.hasOwnProperty("p2pMode")) {
                    setData = Object.assign(setData, {
                        p2pMode: receiveData.p2pMode
                    })
                }
                if (receiveData.hasOwnProperty("allowIframeOpen")) {
                    setData = Object.assign(setData, {
                        allowIframeOpen: receiveData.allowIframeOpen
                    })
                }

                dispatch(setAppBaseWebConfig(setData));
            } else {
                dispatch(setAppBaseWebConfig(""));
            }
        }).catch((error) => {
            dispatch(setAppBaseWebConfig(""));
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
    }
}


export const getIpValidation = async (ip) => {
    let result = {
        status: 0
    }

    try {
        let response = await axios({
            method: "GET",
            url: main_url + "/common/validate-jam-server?ip=" + ip,
        })
        if (response.data.changed == true && response.data.validIp == true) {
            result.status = 2;
            result.response = response;
        } else if (response.data.validIp) {
            result.status = 1;
        }
    }
    catch (e) {
        console.log("getIpValidation error =>", e)
    }
    return result;
}

export const sendRecordingEmailApi = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/send-recording-email",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const deleteMediaFileApi = (data) => {
    return axios({
        method: 'DELETE',
        url: main_url + "/whiteboard/assets/delete",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}


export const makeRoomPayment = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/api/v1/make-room-payment",
        data,
        headers: authToken()
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data,
                    message: error?.response?.message
                }
            }
        })
}
export const updateRoomDetail = (data) => {
    return axios({
        method: 'PUT',
        url: base_url + "/update_owner_Room",
        data,
        headers: authToken()
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data,
                    message: error?.response?.message || error?.response?.data?.message
                }
            }
        })
}

export const getRoomInfo = (roomname) => {
    let token = authToken()
    return axios({
        method: 'get',
        url: base_url + "/roominfo/" + roomname,
        headers: token
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const createConnectLink = (user_id, popUid) => {
    let token = authToken()
    return axios({
        method: 'get',
        url: main_url + "/api/v1/create-connect-account-link?uid=" + user_id + "&session_id=" + popUid,
        headers: token
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data,
                    message: error?.response?.message || error?.response?.data?.message
                }
            }
        })
}

export const getStripeLink = () => {
    let token = authToken()
    return axios({
        method: 'GET',
        url: main_url + "/api/v1/get-stripe-link",
        headers: token
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data,
                    message: error?.response?.message || error?.response?.data?.message
                }
            }
        })
}

export const getMyRecordingsData = (payload) => {
    return (dispatch) => {
        axios({
            method: 'GET',
            url: main_url + "/user-recording-data" + payload,
            headers: authToken()
        })
            .then((res) => {
                let data = res.data;
                dispatch(setMyRecordingsData(data));
                dispatch(hideApiLoader(7));
            }).catch((error) => {
                dispatch(setMyRecordingsData(''));
                dispatch(hideApiLoader(8))
                if (error.response) {
                    console.log("getMyRecordingsData error =>", {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    })
                }
            })
    }
}

export const searchMyRecordingsData = (payload) => {
    return (dispatch) => {
        dispatch(showApiLoader());
        axios({
            method: 'GET',
            url: main_url + "/search-recording-data" + payload,
            headers: authToken()
        })
            .then((res) => {
                let data = res.data;
                dispatch(setMyRecordingsData(data));
            }).catch((error) => {
                dispatch(setMyRecordingsData(''));
                if (error.response) {
                    console.log("searchMyRecordingsData error =>", {
                        status: 0,
                        error: error.response.status,
                        data: error?.response?.data
                    })
                }
            }).finally(() => {
                dispatch(hideApiLoader(9));
            })
    }
}

export const deleteMyRecording = (payload, cb) => {
    return axios({
        method: 'DELETE',
        url: main_url + "/delete-recording?_id=" + payload,
        headers: authToken()
    })
        .then((res) => {
            let data = res.data;
            if (res.data.status) {
                if (cb) {
                    cb();
                }
                // dispatch(setMyRecordingsData(Array.isArray(data) ? data : []));
                dispatch(
                    setNotificationMessage({
                        isOpen: true,
                        type: NotificationType.SUCCESS,
                        message: ct("stripeMessage.recordingDeleted", "stripeMessage")
                    })
                );
                setTimeout(() => {
                    dispatch(
                        setNotificationMessage({
                            isOpen: false,
                            type: null,
                            message: null,
                        })
                    );
                }, 5000);
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            dispatch(setMyRecordingsData(''));
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const endConferenceA = (payload) => {
    return axios({
        method: 'GET',
        url: main_url + "/common/end-conference" + payload,
        headers: authToken()
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}
export const thirdPartyMakeHostApi = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/recommended-third-party",
        data
    })
        .then((res) => {
            if (res.data.status) {
                let noChangedRoomName = getBaseConfig('noChangedRoomName')
                if (noChangedRoomName == true) {
                    dispatch(setRoomorIpAddress(res.data?.newRoomName, 'request thirdPartyMakeHostApi'));
                }
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const userHangupApi = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/user-hangup",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const verifySocialToken = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/user-authorization",
            data
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}


export const getDeviceStatus = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/common/get-device-status",
            data,
            headers: authToken()
        })

        if (res.data.hasOwnProperty("availableDevice")) {
            dispatch(setPrejoinAvailableDevices(res.data.availableDevice))
        }

        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data,
                is_multiple: res.data?.is_multiple || false,
                availableDevice: res?.data?.availableDevice || []
            }
        } else {
            if (res?.data?.is_multiple != undefined) {
                if (res.data?.data?.length) {
                    return {
                        status: 1,
                        data: res.data?.data,
                        is_multiple: res.data?.is_multiple || false,
                        availableDevice: res?.data?.availableDevice || []
                    }
                }
            }
            return {
                status: 0,
                availableDevice: res?.data?.availableDevice || []
            }
        }
    } catch (e) {
        console.log("getDeviceStatus error =>", e)
        return {
            status: 0,
            availableDevice: []
        }
    }
}
export const getDeviceMessage = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/common/get-device-message",
            data
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }

    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getUserBox = (data) => {
    return (dispatch) => {
        axios({
            method: 'POST',
            url: main_url + "/common/get-user-box",
            data,
            headers: authToken()
        }).then((res) => {
            if (res.data.status) {
                let set_devices = [];
                let allDevices = [];
                if (res.data.data) {

                    let data = res.data.data;
                    // show that device which has device list filled and match with device_id
                    let device_list = {};
                    let all_ip = []

                    if (data) {
                        data.device_list.map(e => {
                            device_list[e.device_id] = e.device_ip;
                            all_ip.push(e.device_ip)
                        });

                        for (let i = 0; i < data.device_list.length; i++) {
                            let d_id = data.device_list[i].device_id;
                            if (device_list[d_id] != undefined) {
                                set_devices.push(d_id)
                            }
                        }
                        dispatch(setAvilableUserIP(all_ip))
                    }
                }

                if (res.data.hasOwnProperty("allDevices")) {
                    allDevices = res.data.allDevices;
                }

                dispatch(setRegisteredDevice(set_devices, allDevices))
            } else {
                return {
                    status: 0
                }
            }
        }).catch(e => {
            console.log("getUserBox error =>", e)
        })
    }
}

export const addDeviceBox = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/common/add-user-box",
            data,
            headers: authToken()
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getDeviceRoomApi = async (payload) => {
    try {
        let res = await axios({
            method: 'GET',
            url: main_url + "/device-room" + payload,
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    deviceRoom: res.data.deviceRoom
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const removeBoxErrorApi = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/common/remove-user-box-error",
            data,
            headers: authToken()
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }

    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getMyClaimedRoomsApi = async () => {
    try {
        let res = await axios({
            method: 'GET',
            url: main_url + "/get-my-claimed-rooms",
            headers: authToken()
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getOtherRoomsApi = async () => {
    try {
        let res = await axios({
            method: 'GET',
            url: main_url + "/get-other-rooms",
            headers: authToken()
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const hostHangupApi = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/host-hangup",
            data
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const hostHangupNewApi = async (data) => {
    console.log("host hangup flow 8 =>", data)
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/host-hangup-new",
            data
        })
        if (res.data.status) {
            console.log("host hangup flow 9 =>", res.data.status)
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            console.log("host hangup flow 10 =>")
            return {
                status: 0
            }
        }
    } catch (e) {
        console.log("host hangup flow 11 =>")
        return {
            status: 0
        }
    }
}

export const getFriendList = async (type, search = '', currentPage = 1, filters1 = null) => {
    try {
        var myHeaders = new Headers();
        var formdata = new FormData();
        const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX);

        formdata.append("user_id", userLoginData?.user?.rtaSocialUserId);
        formdata.append("page", currentPage);
        formdata.append("type", type);
        formdata.append("keyword", search);

        if (filters1) {
            for (const key in filters1) {
                formdata.append(`${key}`, `${filters1[key]}`);
            }
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        return fetch(`${social_api_url}/index.php/api/user/getFriendsList`, requestOptions)
            .then(response => response.json())
            .then(result => result)
            .catch(error => error);
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getInstrumentsList = async () => {
    let result = { status: 0 }
    try {
        let res = await axios({
            method: 'GET',
            url: `${social_api_url}/index.php/api/user/getinstruments`,
        })

        if (res.data) {
            result.status = 1;
            result.data = res.data;
        }

        return result;
    } catch (e) {
        return result
    }
}

export const sendEmailInviteFromPopup = async (data) => {


    try {
        var myHeaders = new Headers();
        var formdata = new FormData();

        const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX);

        formdata.append("user_id", userLoginData?.user?.rtaSocialUserId);
        formdata.append("friends", data.friends);
        formdata.append("subject", data.subject);
        formdata.append("message", data.message);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        return fetch(`${social_api_url}/api/user/sendInvitationRequest`, requestOptions)
            .then(response => response.json())
            .then(result => result)
            .catch(error => error);
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const prejoinDeviceCalc = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/pre-meeting",
            data
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const loginGuestUser = async (data) => {
    try {
        let res = await axios({
            method: 'PUT',
            url: main_url + "/common/invite-user-update",
            data,
            headers: authToken()
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }

    } catch (e) {
        return {
            status: 0
        }
    }
}

export const updateUserJamStateReq = async (data) => {
    try {
        let res = await axios({
            method: 'PUT',
            url: main_url + "/common/update-user-jamming-status",
            data,
            headers: authToken()
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0
            }
        }

    } catch (e) {
        return {
            status: 0
        }
    }
}

export function saveUnClaimedRoomReq(data) {
    try {
        let token = authToken()
        axios({
            method: 'POST',
            url: base_url + "/unclaimed-room",
            data,
            headers: token
        }).then(e => {
            console.log("saveUnClaimedRoomReq then =>", e)
        })
    } catch (e) {
        console.log("saveUnClaimedRoomReq error =>", e)
    }
}

export const verifyAuthTokenAsync = async (token) => {
    try {
        let res = await axios({
            method: 'get',
            url: base_url + "/validateToken",
            headers: {
                Authorization: 'Bearer ' + token
            }
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0,
                flag: 2
            }
        }

    } catch (e) {
        return {
            status: 0,
            flag: 3,
            er: e
        }
    }
}

export const onUserLogout = (socialId = null) => {
    const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX);
    return axios({
        method: 'get',
        url: social_api_url + `/users/api_logout/${socialId || userLoginData?.user?.rtaSocialUserId}/true`,
    })
        .then((res) => {
            return {
                status: 1,
                data: res.data
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const addRoomSessionReq = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/v3/add-room-session",
            data,
            headers: authToken()
        })
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data,
                flag: res.data?.flag || 0
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getMyDevicesData = () => {
    try {
        return (dispatch) => {
            axios({
                method: 'GET',
                url: main_url + "/common/user-device",
                headers: authToken()
            })
                .then((res) => {
                    let data = res.data;
                    dispatch(setMyDevicesData(data));
                    dispatch(hideApiLoader(10));
                }).catch((error) => {
                    dispatch(setMyDevicesData(''));
                    dispatch(hideApiLoader(11))
                    if (error.response) {
                        console.log("getMyDevicesData error =>", {
                            status: 0,
                            error: error.response.status,
                            data: error?.response?.data
                        })
                    }
                })
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getDevicePingStatus = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/common/get-device-ping",
            data,
            headers: authToken()
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const reminderEmailToRoomOwner = async (data) => {
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/common/join-room-reminder",
            data,
            headers: authToken()
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getBoxRoomApi = async (payload) => {
    try {
        let res = await axios({
            method: 'GET',
            url: main_url + "/box-room" + payload,
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    deviceRoom: res.data.deviceRoom
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const saveDeviceConnectSession = async (data) => {
    try {
        let res = await axios({
            method: 'PUT',
            url: main_url + "/v2/rta-box-connected",
            data,
            headers: authToken()
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getUserLocation = async () => {
    // let's set return response we dont have to get values based on received data, it will show data in catch or in error as well but data keys will be empty
    let basicInfo = {
        user_city: "",
        user_region: "",
        user_country: "",
        user_ip: ""
    }

    try {
        let res = await axios({
            method: 'GET',
            url: "https://ipapi.co/json"
        })
        if (res) {
            // if (res.data) {

            if (Object.keys(res.data).length) {
                basicInfo = {
                    user_city: res.data.city || "",
                    user_region: res.data.region || "",
                    user_country: res.data.country_name || "",
                    user_ip: res.data.ip || ""
                }
            }
            return {
                status: 1,
                data: res.data,
                basicInfo
            }
            // }
        }
        return {
            status: 0,
            basicInfo
        }
    } catch (e) {
        return {
            status: 0,
            basicInfo
        }
    }
}


export const getTranslatedText = (data) => {
    return axios({
        method: 'post',
        url: "http://localhost:3055/translate-language",
        data
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const updateUserLanguage = (data) => {
    return axios({
        method: 'put',
        url: main_url + "/update-user-language",
        data,
        headers: authToken()
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const getUserLanguage = async () => {
    try {
        let res = await axios({
            method: 'GET',
            url: main_url + "/get-user-language",
            headers: authToken()
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            }
        }
        return {
            status: 0
        }
    } catch (e) {
        return {
            status: 0
        }
    }
}

export const getNatTypeApi = async (data) => {
    // console.log("NAT getNatTypeApi 0 =>", data)
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/symmetric-participant",
            data
        })
        if (res) {
            // console.log("NAT getNatTypeApi 1 =>", res)
            if (res.data.status) {
                // console.log("NAT getNatTypeApi 2 =>", res.data)
                return {
                    status: 1,
                    data: res.data
                }
            }
        }
        // console.log("NAT getNatTypeApi 3 =>")
        return {
            status: 0
        }
    } catch (e) {
        // console.log("NAT getNatTypeApi 4 =>", e)
        return {
            status: 0
        }
    }
}

export const getHybridSessionStatus = async (room) => {
    try {
        let res = await axios({
            method: 'GET',
            url: main_url + "/status-audio-route?&roomname=" + room
        })
        if (res) {
            if (res.data.status) {
                return {
                    status: 1,
                    processStatus: res.data.processStatus
                }
            }
        }
        console.log("i have found an e")

        return {
            status: 0
        }
    } catch (e) {
        console.log("i have found an error while checking hybrid status ", e)
        return {
            status: 0
        }
    }
}


export const kickoutHybridUser = (id) => {
    return axios({
        method: 'GET',
        url: main_url + "/common/terminate-conference-user?participant_id=" + id,
    })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: 1,
                    data: res.data?.data
                }
            } else {
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
}

export const saveStemRecordingUrl = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/save-stem-recording-url",
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0,
                data: res.data
            }
        }
    }).catch((error) => {
        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const checkRoomSessionApi = (data) => {
    return axios({
        method: 'POST',
        url: main_url + "/common/check-room-session",
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data?.data
            }
        } else {
            return {
                status: 0,
                data: res.data
            }
        }
    }).catch((error) => {
        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const getFirewallTypeApi = async (data) => {
    console.log("Firewall getFirewallTypeApi 0 =>", data)
    try {
        let res = await axios({
            method: 'POST',
            url: main_url + "/firewall-participant",
            data
        })
        if (res) {
            console.log("Firewall getFirewallTypeApi 1 =>", res)
            if (res.data.status) {
                console.log("Firewall getFirewallTypeApi 2 =>", res.data)
                return {
                    status: 1,
                    data: res.data
                }
            }
        }
        console.log("Firewall getFirewallTypeApi 3 =>")
        return {
            status: 0
        }
    } catch (e) {
        console.log("Firewall getFirewallTypeApi 4 =>", e)
        return {
            status: 0
        }
    }
}